<script setup lang="ts">
import { useTeacherStore } from "@/store/teacher";

defineOptions({
	name: "teacher.dashboard",
});
definePage({
	name: "teacher.dashboard",
});

const teacherStore = useTeacherStore();

const schoolName = ref("");
const chartData = ref();
const numOfSchools = ref(0);
const numOfClasses = ref(0);
const scheduleEventsToday = ref([]);
const scheduleEventsTomorrow = ref([]);
const dashboardPage = ref<HTMLElement | null>(null);

onMounted(async () => {
	try {
		const res = await teacherStore.getTeacherDashboard();
		console.log(res);
		chartData.value = {
			accepted: res.accepted,
			pending: res.pending,
			rejected: res.rejected,
		};
		numOfSchools.value = res.schools_count;
		numOfClasses.value = res.total_class_count_employer;
		schoolName.value = res.employer.scl_name;
		// for (const event of res.today) {
		// 	scheduleEventsToday.value.push({
		// 		class: event.crq_title,
		// 		location: event.slc_address,
		// 		startDate: event.cls_start,
		// 		endDate: event.cls_end,
		// 	});
		// }
		// for (const event of res.tomorrow) {
		// 	scheduleEventsTomorrow.value.push({
		// 		class: event.crq_title,
		// 		location: event.slc_address,
		// 		startDate: event.cls_start,
		// 		endDate: event.cls_end,
		// 	});
		// }

		scheduleEventsToday.value = res.today
			.map((event) => ({
				class: event.crq_title,
				location: event.slc_address,
				startDate: event.cls_start,
				endDate: event.cls_end,
			}))
			.sort(
				(a, b) =>
					new Date(a.startDate).getTime() - new Date(b.startDate).getTime(),
			);

		scheduleEventsTomorrow.value = res.tomorrow
			.map((event) => ({
				class: event.crq_title,
				location: event.slc_address,
				startDate: event.cls_start,
				endDate: event.cls_end,
			}))
			.sort(
				(a, b) =>
					new Date(a.startDate).getTime() - new Date(b.startDate).getTime(),
			);
	} catch (e) {
		console.error(e);
	}
});
</script>

<template>
	<div
		id="dashboard-page"
		ref="dashboardPage"
	>
		<div class="right-wrap">
			<chart-comp
				v-if="chartData"
				:data="chartData"
			/>
			<div class="stats-wrap">
				<div class="stat-section">
					<div class="stat-title">
						<div class="icon">
							<i-mdi-search />
						</div>
						<div class="title">
							{{ $t("app.teacher.dashboard.stats.employer") }}
						</div>
					</div>
					<div class="stat-stat">
						<div class="content">{{ schoolName }}</div>
						<div class="subtitle">
							{{
								$t("app.teacher.dashboard.stats.classes", {
									number: numOfClasses,
								})
							}}
						</div>
					</div>
				</div>
				<div class="stat-section">
					<div class="stat-title">
						<div class="icon">
							<i-mdi-calendar />
						</div>
						<div class="title">
							{{ $t("app.teacher.dashboard.stats.workedWith") }}
						</div>
					</div>
					<div class="stat-stat">
						<div class="content">
							{{
								$t("app.teacher.dashboard.stats.schools", {
									number: numOfSchools,
								})
							}}
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="left-wrap">
			<div class="schedule-wrap">
				<div class="title-wrap">
					{{ $t("app.teacher.dashboard.schedule.title") }}
				</div>
				<schedule-card
					:title="$t('app.teacher.dashboard.schedule.today')"
					:events="scheduleEventsToday"
				/>
				<schedule-card
					:title="$t('app.teacher.dashboard.schedule.tomorrow')"
					:events="scheduleEventsTomorrow"
				/>
			</div>
			<!-- TODO: Make this rout to a page -->
			<p-button
				as="router-link"
				to="/teacher/calendar"
				style="white-space: nowrap; width: fit-content"
			>
				<i-mdi-calendar-month-outline />
				{{ $t("app.teacher.dashboard.button.seeMoreBtn") }}
			</p-button>
		</div>
	</div>
</template>

<style lang="scss" scoped>
#dashboard-page {
	display: flex;
	flex-direction: row-reverse;
	padding-top: 40px;
	padding-bottom: 40px;
	justify-content: space-around;
	box-sizing: border-box;
	height: calc(100dvh - $nav-top-bar - 1px);
	overflow-y: auto;

	.left-wrap {
		width: 50%;
		display: flex;
		flex-direction: column;
		gap: 20px;
		height: fit-content;

		&:deep(.p-button) {
			font-size: 20px;
			font-weight: 700;
			width: 275px;
			height: 50px;
		}

		.schedule-wrap {
			width: 100%;
			display: flex;
			flex-direction: column;
			gap: 20px;

			.title-wrap {
				font-size: 20px;
				font-weight: 700;
				color: $daidai-dark-blue;
				padding-left: 20px;
			}
		}
	}

	.right-wrap {
		width: 45%;
		display: flex;
		flex-direction: column;
		gap: 20px;
		height: fit-content;

		.stats-wrap {
			display: flex;
			flex-direction: column;
			gap: 30px;
			padding-top: 50px;

			.stat-section {
				display: flex;
				flex-direction: column;

				.stat-title {
					display: flex;
					flex-direction: row;
					align-items: center;
					gap: 10px;
					padding-bottom: 10px;
					.icon {
						svg {
							color: $daidai-yellow;
							width: 20px;
							height: 20px;
						}
					}

					.title {
						font-size: 16px;
						color: $daidai-middle-blue;
					}
				}

				.stat-stat {
					font-size: 28px;
					color: $daidai-dark-blue;
					padding-left: 30px;

					.subtitle {
						font-size: 16px;
						font-weight: 600;
						color: $daidai-middle-blue;
					}

					.content {
						display: flex;
						flex-direction: row;
						gap: 10px;
					}
				}
			}
		}
	}
}

@media (max-width: 768px) {
	#dashboard-page {
		flex-direction: column;
		justify-content: unset;

		.left-wrap {
			width: 100%;
			padding: 0 20px;
			padding-bottom: 20px;
			margin-top: 20px;
			align-items: flex-end;

			.schedule-wrap {
				.title-wrap {
					padding-left: 0;
					text-align: center;
				}
			}
		}
		.right-wrap {
			width: 100%;

			.stats-wrap {
				padding: 0 20px;
			}
		}
	}
}
</style>
